import AsyncList from './AsyncList';

export default AsyncList;